export default __webpack_public_path__ + "static/media/delete-icon.19e2d26d.svg";